import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    nav: ''
  },
  mobileNavIconSize: 'md'
} satisfies RecursivePartial<CMSConfig['megaMenu']>
